<script>
import Repositories from '@/repositories';
const WorkOrdersRepository = Repositories.get('workorders');
import UserConfigMixin from '@/mixins/userConfigMixin';
import CalendarApiService from '@/services/calendarService';
import CustomFieldService from '@/services/customFieldService';
import RadialProgressBar from 'vue-radial-progress';
import { utils, writeFileXLSX } from 'xlsx';
import ProgressStartModal from '../modals/progressStartModal.vue';
import CompleteStepsBeforeModal from '../../modals/completeStepsBeforeModal.vue';

export default {
    mixins: [UserConfigMixin],
    components: {
        RadialProgressBar,
        ProgressStartModal,
        CompleteStepsBeforeModal,
    },
    model: {
        prop: 'model',
        event: 'input',
    },
    props: ['model', 'customFields', 'progressColumns'],
    data() {
        return {
            workOrders: [],
            totalRows: 0,
            innerStrokeColor: '#cfcfcf',
            pagesize: 30,
            page: 1,
            // Custom field text edit modal
            textEditModal: {
                show: false,
                workOrder: null,
                customField: null,
                textValue: '',
            },
            // Custom field dropdown edit modal
            dropdownModal: {
                show: false,
                workOrder: null,
                customField: null,
                selectedOptionId: null,
            },
            // Progress users modal
            progressUsersModal: {
                show: false,
                workOrder: null,
                progress: null,
                availableUsers: [],
                selectedUsers: [],
                isLoading: false,
                hasEvent: false,
            },
            // Export loading state
            isExporting: false,
        };
    },
    created() {
        this.pagesize = localStorage.getItem('workorderlist.pagesize') ?? 30;
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        reset() {
            this.page = 1;
            this.$refs.selectableTable.refresh();
        },
        refresh() {
            this.$refs.selectableTable.refresh();
        },
        buildFilters(options = {}) {
            const { page, pagesize, sortBy, sortDesc } = options;

            // Detect if sorting by custom field
            let customFieldSortIdPublic = undefined;
            let customFieldSortDesc = undefined;
            let standardSortBy = sortBy;

            if (sortBy && sortBy.startsWith('customField_')) {
                customFieldSortIdPublic = sortBy.replace('customField_', '');
                customFieldSortDesc = sortDesc;
                standardSortBy = undefined;
            }

            const filters = {
                currentDate: new Date().toDateString(),
                sortby: standardSortBy,
                sortdesc: standardSortBy ? sortDesc?.toString() : undefined,
                customfieldsortidpublic: customFieldSortIdPublic,
                customfieldsortdesc: customFieldSortIdPublic ? customFieldSortDesc?.toString() : undefined,
                search: this.model.filters.search,
                workordertypes: this.model.filters.workOrderType
                    ? [this.model.filters.workOrderType.idPublic]
                    : undefined,
                workOrdergroups: this.model.filters.workOrderGroups.map((x) => {
                    return x.idPublic;
                }),
                roomName: this.model.filters.roomName,
                clientName: this.model.filters.clientName,
                contractor: this.model.filters.contractor,
                projectmanager: this.model.filters.projectManager,
                templates: this.model.filters.template
                    ? [this.model.filters.template.idPublic]
                    : undefined,
                installers: this.model.filters.installers.map((i) => {
                    return i.idPublic;
                }),
                shippers: this.model.filters.shippers.map((s) => {
                    return s.idPublic;
                }),
                stepsCompleted: this.model.filters.steps && this.model.filters.steps.length > 0
                    ? this.model.filters.steps.map((s) => s.stepIdPublic)
                    : undefined,
                assignedUserIds: this.model.filters.assignedUsers && this.model.filters.assignedUsers.length > 0
                    ? this.model.filters.assignedUsers.map((u) => u.id)
                    : undefined,
                showcompleted: this.model.filters.showCompleted.toString(),
                showNoTemplateOnly: this.model.filters.showNoTemplateOnly.toString(),
                deliveryDateRangeFromStartDate:
                    this.model.filters.deliveryDateRange &&
                    this.model.filters.deliveryDateRange[0]
                        ? this.$dayjs(
                              this.model.filters.deliveryDateRange[0]
                          ).format('YYYY-MM-DD')
                        : null,
                deliveryDateRangeToStartDate:
                    this.model.filters.deliveryDateRange &&
                    this.model.filters.deliveryDateRange[1]
                        ? this.$dayjs(
                              this.model.filters.deliveryDateRange[1]
                          ).format('YYYY-MM-DD')
                        : null,
                installationDateRangeFromStartDate:
                    this.model.filters.installationDateRange &&
                    this.model.filters.installationDateRange[0]
                        ? this.$dayjs(
                              this.model.filters.installationDateRange[0]
                          ).format('YYYY-MM-DD')
                        : null,
                installationDateRangeToStartDate:
                    this.model.filters.installationDateRange &&
                    this.model.filters.installationDateRange[1]
                        ? this.$dayjs(
                              this.model.filters.installationDateRange[1]
                          ).format('YYYY-MM-DD')
                        : null,
                productionDateRangeFromStartDate:
                    this.model.filters.productionDateRange &&
                    this.model.filters.productionDateRange[0]
                        ? this.$dayjs(
                              this.model.filters.productionDateRange[0]
                          ).format('YYYY-MM-DD')
                        : null,
                productionDateRangeToStartDate:
                    this.model.filters.productionDateRange &&
                    this.model.filters.productionDateRange[1]
                        ? this.$dayjs(
                              this.model.filters.productionDateRange[1]
                          ).format('YYYY-MM-DD')
                        : null,
            };

            // Only include pagination if values are provided
            if (page != null) {
                filters.page = page;
            }
            if (pagesize != null) {
                filters.pagesize = pagesize;
            }

            return filters;
        },
        loadWorkOrders(ctx, callback) {
            if (!this.model.filters || !this.model.filters.ready) {
                return [];
            }
            console.log(ctx);

            const filters = this.buildFilters({
                page: ctx.currentPage,
                pagesize: ctx.perPage,
                sortBy: ctx.sortBy,
                sortDesc: ctx.sortDesc,
            });

            WorkOrdersRepository.get(filters).then((response) => {
                this.workOrders = response.data.items;
                this.totalRows = response.data.totalCount;
                callback(this.workOrders);
            });
        },
        getWorkOrderValue(measureType, workOrder) {
            let value = null;
            if (!workOrder.workOrderValues) {
                return value;
            }
            let workOrderValue = workOrder.workOrderValues.filter((x) => {
                return x.item1 == measureType;
            });
            if (workOrderValue.length > 0) {
                value = workOrderValue[0].item2;
            }

            return value;
        },
        getCustomFieldValue(customField, workOrder) {
            if (!workOrder.customFieldValues) {
                return '';
            }
            const fieldValue = workOrder.customFieldValues.find(
                (cfv) => cfv.customFieldIdPublic === customField.idPublic
            );
            if (!fieldValue) {
                return '';
            }
            // For checkbox type, show checkmark or empty
            if (customField.type === 'Checkbox') {
                return fieldValue.boolValue === true ? '✓' : '';
            }
            // For text type
            if (customField.type === 'Text') {
                return fieldValue.textValue || '';
            }
            // For dropdown type, find option name
            if (customField.type === 'Dropdown' && fieldValue.customFieldOptionId) {
                const option = customField.customFieldOptions?.find(
                    (opt) => opt.id === fieldValue.customFieldOptionId
                );
                return option?.name || '';
            }
            return fieldValue.textValue || '';
        },
        toggleWorkOrderSteps(row) {
            row.toggleDetails();

            if (!row.detailsShowing) {
                this.$set(row.item, 'isLoading', true);
                row.item.isLoading = true;
                this.getProgress(row);
            }
        },
        checkIfIsLate(item) {
            if (item.status === 'Pending') {
                return item.startDate === null
                    ? false
                    : new Date(item.startDate) < new Date()
                    ? true
                    : false;
            }
            if (item.status === 'Started') {
                return item.endDate === null
                    ? false
                    : new Date(item.endDate) < new Date()
                    ? true
                    : false;
            }
            return false;
        },
        getProgressBarColor(percent) {
            if (percent == 1) {
                return '#34c38f';
            } else if (percent == 0) {
                return 'rgba(52, 58, 64, 0.31)';
            } else {
                return '#f1b44c';
            }
        },
        openWorkOrderProgressDetails(item, row) {
            this.$refs.progressStartModal.show(item).then((response) => {
                if (response == 'complete') {
                    this.openCompleteStepsBeforeModal(item, row);
                }
                if (response == 'start') {
                    row.item.isLoading = true;
                    this.startProgressAppointment(item).then(() => {
                        this.getProgress(row);
                    });
                }
            });
        },
        openCompleteStepsBeforeModal(item, row) {
            CalendarApiService.getProgressConfig(item.progress.id).then(
                (response) => {
                    let config = response.data.data;

                    if (
                        config.askToCompletePreviousProgress == true &&
                        item.progress.id != item.nextStepToCompleteId
                    ) {
                        this.$refs.completeStepsBeforeModal.show().then(
                            (userResponse) => {
                                row.item.isLoading = true;
                                this.completeProgressAppointment(
                                    item,
                                    userResponse
                                ).then(() => {
                                    this.getProgress(row);
                                });
                            },
                            () => {}
                        );
                    } else {
                        row.item.isLoading = true;
                        this.completeProgressAppointment(item, true).then(
                            () => {
                                this.getProgress(row);
                            }
                        );
                    }
                }
            );
        },
        completeProgressAppointment(
            progressAppointment,
            completeProgressBefore = false
        ) {
            return CalendarApiService.completeProgressAppointment(
                progressAppointment.workOrderStepIdPublic,
                completeProgressBefore
            );
        },
        startProgressAppointment(progressAppointment) {
            return CalendarApiService.startProgressAppointment(
                progressAppointment.workOrderStepIdPublic
            );
        },
        getProgress(row) {
            CalendarApiService.getWorkOrderProgress(row.item.idPublic).then(
                (response) => {
                    var orderedProgress = response.data.data
                        .sort((a, b) =>
                            a.progress.order > b.progress.order
                                ? 1
                                : b.progress.order > a.progress.order
                                ? -1
                                : 0
                        )
                        .map((x) => {
                            return {
                                ...x,
                                isLate: this.checkIfIsLate(x),
                            };
                        });

                    let formatedOrderedProgress = orderedProgress.map(
                        (progress, i) => {
                            return {
                                ...progress,
                                nextStepToCompleteId:
                                    orderedProgress[i + 1]
                                        ?.workOrderStepIdPublic ?? null,
                            };
                        }
                    );

                    row.item.workOrderProgress = formatedOrderedProgress;
                    row.item.isLoading = false;
                }
            );
        },
        async exportExcel() {
            this.isExporting = true;
            try {
                // Fetch all filtered work orders without pagination
                const filters = this.buildFilters({
                    sortBy: this.$refs.selectableTable?.sortBy,
                    sortDesc: this.$refs.selectableTable?.sortDesc,
                });
                console.log('Export - filters being sent:', filters);
                const response = await WorkOrdersRepository.get(filters);
                console.log('Export - API response:', response);
                console.log('Export - response.data:', response.data);
                const allWorkOrders = response.data.items;
                console.log('Export - allWorkOrders count:', allWorkOrders?.length);
                if (allWorkOrders?.length > 0) {
                    console.log('Export - first work order:', allWorkOrders[0]);
                }

                // SheetJS
                const ws = utils.json_to_sheet(
                    allWorkOrders.map((row) => {
                        let dynamicRow = {};

                        delete row.workOrderStepsStatuses;
                        delete row.idPublic;
                        row.lastCompletedStep = row.lastCompletedStep?.name;

                        for (let field of this.fields) {
                            // Use label as header instead of key
                            const header = field.label || field.key;
                            if (field.formatter != undefined) {
                                dynamicRow[header] = field.formatter(
                                    undefined,
                                    field.key,
                                    row
                                );
                            } else {
                                dynamicRow[header] = row[field.key] ?? '';
                            }
                        }
                        return dynamicRow;
                    })
                );

                ws['!autofilter'] = { ref: 'A1:Z1' };
                const wb = utils.book_new();
                utils.book_append_sheet(wb, ws, 'Data');
                writeFileXLSX(
                    wb,
                    `workorders-export-${this.$dayjs(new Date()).format('L')}.xlsx`
                );
            } finally {
                this.isExporting = false;
            }
        },
        // Custom field inline editing methods
        onCustomFieldCellClick(customField, workOrder) {
            console.log('Cell clicked - customField:', customField, 'workOrder:', workOrder.idPublic);
            if (!customField) {
                return;
            }
            // Types: "Text", "Checkbox", "Dropdown"
            if (customField.type === 'Checkbox') {
                this.toggleCheckboxValue(customField, workOrder);
            } else if (customField.type === 'Text') {
                this.openTextEditModal(customField, workOrder);
            } else if (customField.type === 'Dropdown') {
                this.openDropdownModal(customField, workOrder);
            }
        },
        toggleCheckboxValue(customField, workOrder) {
            console.log('toggleCheckboxValue called');
            const existingValue = workOrder.customFieldValues?.find(
                (cfv) => cfv.customFieldIdPublic === customField.idPublic
            );
            console.log('existingValue:', existingValue);
            const currentBoolValue = existingValue?.boolValue === true;
            const newBoolValue = !currentBoolValue;
            console.log('currentBoolValue:', currentBoolValue, '-> newBoolValue:', newBoolValue);

            console.log('Calling API with:', workOrder.idPublic, customField.idPublic, null, newBoolValue);
            CustomFieldService.updateValue(
                workOrder.idPublic,
                customField.idPublic,
                null,
                newBoolValue
            ).then((response) => {
                console.log('API success:', response);
                // Update local state
                if (!workOrder.customFieldValues) {
                    this.$set(workOrder, 'customFieldValues', []);
                }
                if (existingValue) {
                    existingValue.boolValue = newBoolValue;
                } else {
                    workOrder.customFieldValues.push({
                        customFieldIdPublic: customField.idPublic,
                        boolValue: newBoolValue,
                        textValue: null,
                    });
                }
                console.log('Local state updated');
            }).catch((error) => {
                console.error('API error:', error);
            });
        },
        openTextEditModal(customField, workOrder) {
            console.log('openTextEditModal called');
            const existingValue = workOrder.customFieldValues?.find(
                (cfv) => cfv.customFieldIdPublic === customField.idPublic
            );
            console.log('existingValue:', existingValue);
            this.textEditModal.workOrder = workOrder;
            this.textEditModal.customField = customField;
            this.textEditModal.textValue = existingValue?.textValue || '';
            this.textEditModal.show = true;
            console.log('Modal should be shown, textEditModal.show:', this.textEditModal.show);
        },
        saveTextValue() {
            const { workOrder, customField, textValue } = this.textEditModal;

            CustomFieldService.updateValue(
                workOrder.idPublic,
                customField.idPublic,
                textValue,
                null
            ).then(() => {
                // Update local state
                if (!workOrder.customFieldValues) {
                    this.$set(workOrder, 'customFieldValues', []);
                }
                const existingValue = workOrder.customFieldValues.find(
                    (cfv) => cfv.customFieldIdPublic === customField.idPublic
                );
                if (existingValue) {
                    existingValue.textValue = textValue;
                } else {
                    workOrder.customFieldValues.push({
                        customFieldIdPublic: customField.idPublic,
                        boolValue: null,
                        textValue: textValue,
                    });
                }
                this.textEditModal.show = false;
            });
        },
        openDropdownModal(customField, workOrder) {
            const existingValue = workOrder.customFieldValues?.find(
                (cfv) => cfv.customFieldIdPublic === customField.idPublic
            );
            this.dropdownModal.workOrder = workOrder;
            this.dropdownModal.customField = customField;
            this.dropdownModal.selectedOptionId = existingValue?.customFieldOptionId || null;
            this.dropdownModal.show = true;
        },
        saveDropdownValue() {
            const { workOrder, customField, selectedOptionId } = this.dropdownModal;

            CustomFieldService.updateValue(
                workOrder.idPublic,
                customField.idPublic,
                null,
                null,
                selectedOptionId
            ).then(() => {
                // Update local state
                if (!workOrder.customFieldValues) {
                    this.$set(workOrder, 'customFieldValues', []);
                }
                const existingValue = workOrder.customFieldValues.find(
                    (cfv) => cfv.customFieldIdPublic === customField.idPublic
                );
                if (existingValue) {
                    existingValue.customFieldOptionId = selectedOptionId;
                } else {
                    workOrder.customFieldValues.push({
                        customFieldIdPublic: customField.idPublic,
                        boolValue: null,
                        textValue: null,
                        customFieldOptionId: selectedOptionId,
                    });
                }
                this.dropdownModal.show = false;
            });
        },
        getCustomFieldFromColumnKey(columnKey) {
            if (!columnKey.startsWith('customField_')) {
                return null;
            }
            const idPublic = columnKey.replace('customField_', '');
            return this.customFields ? this.customFields.find((cf) => cf.idPublic === idPublic) : null;
        },
        getCustomFieldCellClass(columnKey, workOrder) {
            const customField = this.getCustomFieldFromColumnKey(columnKey);
            if (!customField) {
                return { 'custom-field-cell': true };
            }
            const isCheckbox = customField.type === 'Checkbox';
            const isText = customField.type === 'Text';
            const isDropdown = customField.type === 'Dropdown';
            let isChecked = false;
            if (isCheckbox && workOrder.customFieldValues) {
                const fieldValue = workOrder.customFieldValues.find(
                    (cfv) => cfv.customFieldIdPublic === customField.idPublic
                );
                isChecked = fieldValue && fieldValue.boolValue === true;
            }
            return {
                'custom-field-cell': true,
                'custom-field-checkbox': isCheckbox,
                'custom-field-checkbox-checked': isChecked,
                'custom-field-text': isText,
                'custom-field-dropdown': isDropdown,
            };
        },
        isCustomFieldCheckbox(columnKey) {
            const cf = this.getCustomFieldFromColumnKey(columnKey);
            return cf && cf.type === 'Checkbox';
        },
        isCustomFieldChecked(columnKey, workOrder) {
            const cf = this.getCustomFieldFromColumnKey(columnKey);
            if (!cf || cf.type !== 'Checkbox' || !workOrder.customFieldValues) {
                return false;
            }
            const fieldValue = workOrder.customFieldValues.find(
                (cfv) => cfv.customFieldIdPublic === cf.idPublic
            );
            return fieldValue && fieldValue.boolValue === true;
        },
        getCustomFieldCellStyle(columnKey, workOrder) {
            const customField = this.getCustomFieldFromColumnKey(columnKey);
            if (!customField || customField.type !== 'Checkbox') {
                return {};
            }
            const isChecked = this.isCustomFieldChecked(columnKey, workOrder);
            if (isChecked) {
                return { backgroundColor: customField.color || '#556ee6' };
            }
            return {};
        },
        isCustomFieldDropdown(columnKey) {
            const cf = this.getCustomFieldFromColumnKey(columnKey);
            return cf && cf.type === 'Dropdown';
        },
        getProgressAssignedUsers(progress, workOrder) {
            if (!workOrder.progressAssignedUsers) {
                return '';
            }
            const progressData = workOrder.progressAssignedUsers.find(
                (pau) => pau.stepIdPublic === progress.stepIdPublic
            );
            if (!progressData || !progressData.assignedUserNames) {
                return '';
            }
            return progressData.assignedUserNames.join(', ');
        },
        getProgressFromColumnKey(columnKey) {
            if (!columnKey.startsWith('progress_')) {
                return null;
            }
            const stepIdPublic = columnKey.replace('progress_', '');
            return this.progressColumns
                ? this.progressColumns.find((p) => p.stepIdPublic === stepIdPublic)
                : null;
        },
        onProgressCellClick(progress, workOrder) {
            if (!progress) {
                return;
            }
            this.progressUsersModal.isLoading = true;
            this.progressUsersModal.workOrder = workOrder;
            this.progressUsersModal.progress = progress;
            this.progressUsersModal.show = true;

            CalendarApiService.getProgressAppointmentUsers(
                workOrder.idPublic,
                progress.stepIdPublic
            ).then((response) => {
                const data = response.data.data;
                this.progressUsersModal.hasEvent = data.appointmentId != null;
                this.progressUsersModal.availableUsers = data.availableUsers || [];
                // Pre-select assigned users
                this.progressUsersModal.selectedUsers = data.assignedUsers || [];
                this.progressUsersModal.isLoading = false;
            }).catch((error) => {
                console.error('Error loading progress users:', error);
                this.progressUsersModal.isLoading = false;
                this.progressUsersModal.hasEvent = false;
            });
        },
        saveProgressUsers() {
            const { workOrder, progress, selectedUsers } = this.progressUsersModal;

            const model = {
                workOrderIdPublic: workOrder.idPublic,
                stepIdPublic: progress.stepIdPublic,
                userIds: selectedUsers.map((u) => u.id),
            };

            CalendarApiService.updateProgressAppointmentUsers(model)
                .then((response) => {
                    // Update local state
                    if (!workOrder.progressAssignedUsers) {
                        this.$set(workOrder, 'progressAssignedUsers', []);
                    }
                    const existingData = workOrder.progressAssignedUsers.find(
                        (pau) => pau.stepIdPublic === progress.stepIdPublic
                    );
                    const newUserNames = response.data.data || [];
                    if (existingData) {
                        existingData.assignedUserNames = newUserNames;
                    } else {
                        workOrder.progressAssignedUsers.push({
                            stepIdPublic: progress.stepIdPublic,
                            assignedUserNames: newUserNames,
                        });
                    }
                    this.progressUsersModal.show = false;
                })
                .catch((error) => {
                    console.error('Error saving progress users:', error);
                });
        },
        getSelectedDropdownOption(columnKey, workOrder) {
            const cf = this.getCustomFieldFromColumnKey(columnKey);
            if (!cf || cf.type !== 'Dropdown' || !workOrder.customFieldValues) {
                return null;
            }
            const fieldValue = workOrder.customFieldValues.find(
                (cfv) => cfv.customFieldIdPublic === cf.idPublic
            );
            if (!fieldValue || !fieldValue.customFieldOptionId) {
                return null;
            }
            return cf.customFieldOptions?.find(
                (opt) => opt.id === fieldValue.customFieldOptionId
            ) || null;
        },
    },
    computed: {
        fields() {
            const lang = this.$i18n.localeComplete;

            if (!lang) {
                return [];
            }
            // Return the array of translated values
            var tableFields = [];
            if (this.model.cols.showWorkOrderName == true) {
                tableFields.push({
                    key: 'name',
                    label: this.$t('general.workOrder'),
                    sortable: true,
                });
            }
            if (this.model.cols.showClientName == true) {
                tableFields.push({
                    key: 'clientName',
                    label: this.$t('general.clientName2'),
                    sortable: true,
                });
            }
            if (this.model.cols.showClientAddress == true) {
                tableFields.push({
                    key: 'clientAddress',
                    label: this.$t('general.clientAddress'),
                    sortable: true,
                });
            }
            if (this.model.cols.showClientCity == true) {
                tableFields.push({
                    key: 'clientCity',
                    label: this.$t('general.clientCity'),
                    sortable: true,
                });
            }
            if (this.model.cols.showClientEmail == true) {
                tableFields.push({
                    key: 'clientEmail',
                    label: this.$t('general.email'),
                    sortable: true,
                });
            }
            if (this.model.cols.showClientPhone == true) {
                tableFields.push({
                    key: 'clientPhone',
                    label: this.$t('general.clientPhone'),
                    sortable: true,
                });
            }
            if (this.model.cols.showClientState == true) {
                tableFields.push({
                    key: 'clientState',
                    label: this.$t('general.stateProvince'),
                    sortable: true,
                });
            }
            if (this.model.cols.showComment == true) {
                tableFields.push({
                    key: 'comment',
                    label: this.$t('general.comment'),
                    sortable: false,
                });
            }
            if (this.model.cols.showPercentCompleted == true) {
                tableFields.push({
                    key: 'percentCompleted',
                    label: this.$t('general.advancement'),
                    sortable: true,
                });
            }
            if (this.model.cols.showLastCompletedStep == true) {
                tableFields.push({
                    key: 'lastCompletedStep',
                    label: this.$t('general.status'),
                    sortable: true,
                });
            }
            if (this.model.cols.showWorkOrderType == true) {
                tableFields.push({
                    key: 'workOrderTypeName',
                    label: this.$t('general.type'),
                    sortable: true,
                });
            }
            if (this.model.cols.showWorkOrderGroup == true) {
                tableFields.push({
                    key: 'workOrderGroupName',
                    label: this.$t('general.group'),
                    sortable: true,
                });
            }
            if (this.model.cols.showRoomName == true) {
                tableFields.push({
                    key: 'roomName',
                    label: this.$t('general.room'),
                    sortable: true,
                });
            }
            if (this.model.cols.showProjectManager == true) {
                tableFields.push({
                    key: 'projectManager',
                    label: this.$t('general.projectManager'),
                    sortable: true,
                });
            }
            if (this.model.cols.showProductionDate == true) {
                tableFields.push({
                    key: 'productionDate',
                    label: this.$t('general.production'),
                    sortable: true,
                });
            }

            if (this.model.cols.showDeliveryDate == true) {
                tableFields.push({
                    key: 'deliveryDate',
                    label: this.$t('general.delivery'),
                    sortable: true,
                });
            }
            if (this.model.cols.showShipper == true) {
                tableFields.push({
                    key: 'shipper',
                    label: this.$t('general.shipper'),
                    sortable: true,
                    formatter: (value, key, item) =>
                        !item.shipper ? '' : item.shipper.name,
                });
            }

            if (this.model.cols.showInstallationDate == true) {
                tableFields.push({
                    key: 'installationDate',
                    label: this.$t('general.installation'),
                    sortable: true,
                });
            }
            if (this.model.cols.showInstallers == true) {
                tableFields.push({
                    key: 'installers',
                    label: this.$t('general.installers'),
                    sortable: false,
                    formatter: (value, key, item) =>
                        !item.installers || item.installers.length === 0
                            ? ''
                            : item.installers.map((x) => x.name).join(', '),
                });
            }

            if (this.model.cols.showCadCam == true) {
                tableFields.push({
                    key: 'cadCamMerged',
                    label: this.$t('general.CadCam'),
                });
            }

            if (this.model.cols.showLate == true) {
                tableFields.push({
                    key: 'nbLateProgresses',
                    label: this.$t('general.late'),
                });
            }

            if (this.model.cols.showTemplate == true) {
                tableFields.push({
                    key: 'templateName',
                    label: this.$t('general.template'),
                    sortable: true,
                });
            }

            for (let mt of this.measureTypes) {
                if (this.model.cols[mt] == true) {
                    tableFields.push({
                        key: mt,
                        label: this.$t('general.' + mt),
                        sortable: true,
                        formatter: (value, key, item) =>
                            this.getWorkOrderValue(key, item),
                    });
                }
            }

            // Add custom field columns
            if (this.customFields && this.customFields.length > 0) {
                for (let cf of this.customFields) {
                    const colKey = `customField_${cf.idPublic}`;
                    if (this.model.cols[colKey] === true) {
                        tableFields.push({
                            key: colKey,
                            label: cf.name,
                            sortable: true,
                            tdClass: 'custom-field-td',
                            formatter: (value, key, item) =>
                                this.getCustomFieldValue(cf, item),
                        });
                    }
                }
            }

            // Add progress columns (assigned users)
            if (this.progressColumns && this.progressColumns.length > 0) {
                for (let progress of this.progressColumns) {
                    const colKey = `progress_${progress.stepIdPublic}`;
                    if (this.model.cols[colKey] === true) {
                        tableFields.push({
                            key: colKey,
                            label: progress.name,
                            sortable: false,
                            tdClass: 'custom-field-td',
                            formatter: (value, key, item) =>
                                this.getProgressAssignedUsers(progress, item),
                        });
                    }
                }
            }

            if (this.model.cols.showActions == true) {
                tableFields.push({
                    key: 'show_details',
                    label: this.$t('general.actions'),
                });
            }

            return tableFields;
        },
        dropdownModalOptions() {
            if (!this.dropdownModal.customField || !this.dropdownModal.customField.customFieldOptions) {
                return [];
            }
            const options = [
                { value: null, text: this.$t('general.selectOption') }
            ];
            for (const opt of this.dropdownModal.customField.customFieldOptions) {
                options.push({
                    value: opt.id,
                    text: opt.name
                });
            }
            return options;
        },
    },
    watch: {
        pagesize: function() {
            localStorage.setItem('workorderlist.pagesize', this.pagesize);
        },
    },
};
</script>

<template>
    <div class="mb-0 card card-body boxShadow">
        <div class="mt-2 workOrderList">
            <b-table
                class=""
                selectable
                @row-selected="(rows) => $emit('select-workorders', rows)"
                select-mode="multi"
                sticky-header
                responsive
                outlined
                hover
                head-variant="light"
                ref="selectableTable"
                style="flex: 1 1 0; max-height: 100%; scrollbar-width: thin"
                :items="loadWorkOrders"
                :fields="fields"
                :per-page="pagesize"
                :current-page="page"
                :filter="model.filters"
                :sort-by="model.filters.sort.by"
                :sort-desc="model.filters.sort.desc"
                :no-sort-reset="true"
            >
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner
                            class="align-middle"
                            style="color: rgba(243, 168, 33, 0.7) !important"
                        ></b-spinner>
                    </div>
                </template>
                <template #head(name)="data">
                    <div>
                        {{ data.label }}
                    </div>
                </template>
                <template #head()="data">
                    <div style="text-align: center;">
                        {{ data.label }}
                    </div>
                </template>
                <template #cell(name)="data">
                    <div>
                        {{ data.value }}
                    </div>
                </template>

                <template #cell(percentCompleted)="data">
                    <div style="text-align: center">
                        <b-badge
                            :style="{
                                'background-color':
                                    data.item.percentCompleted == 1
                                        ? '#34c38f'
                                        : data.item.percentCompleted == 0
                                        ? 'rgba(52, 58, 64, 0.31)'
                                        : '#f1b44c',
                            }"
                            style="font-size: 1.1em"
                            >{{
                                (data.item.percentCompleted * 100).toFixed(0)
                            }}%</b-badge
                        >
                    </div>
                </template>

                <template #cell(lastCompletedStep)="data">
                    <div style="text-align: center">
                        <b-badge
                            v-if="data.item.lastCompletedStep"
                            :style="{
                                'background-color':
                                    data.item.lastCompletedStep.colorHexa,
                            }"
                            style="font-size: 1.1em"
                            >{{ data.item.lastCompletedStep.name }}</b-badge
                        >
                    </div>
                </template>

                <template #cell(cadCamMerged)="data">
                    <div style="text-align: center">
                        <i
                            v-if="data.item.cadCamMerged == true"
                            class="bx bx-check-circle"
                            style="font-size: 1.6em; color: #34c38f"
                        />
                    </div>
                </template>

                <template #cell(productionDate)="data">
                    {{
                        !data.item.productionDate
                            ? ''
                            : $dayjs(data.item.productionDate).format('L')
                    }}
                </template>

                <template #cell(deliveryDate)="data">
                    {{
                        !data.item.deliveryDate
                            ? ''
                            : $dayjs(data.item.deliveryDate).format('L')
                    }}
                </template>

                <template #cell(installationDate)="data">
                    {{
                        !data.item.installationDate
                            ? ''
                            : $dayjs(data.item.installationDate).format('L')
                    }}
                </template>

                <template #cell(nbLateProgresses)="data">
                    <div style="text-align: center">
                        <div
                            class="d-flex"
                            v-if="data.item.nbLateProgresses >= 1"
                        >
                            {{ data.item.nbLateProgresses }}
                            <i
                                class="bx bx-time bx-tada pl-1"
                                style="color: #ff0000; font-size: large"
                            ></i>
                        </div>
                        <div v-else class="d-flex">
                            <i
                                class="bx bx-time"
                                style="color: #6cc855; font-size: large"
                            ></i>
                        </div>
                    </div>
                </template>

                <template #cell()="data">
                    <template v-if="data.field.key.startsWith('customField_')">
                        <div
                            @click.stop="onCustomFieldCellClick(getCustomFieldFromColumnKey(data.field.key), data.item)"
                            :class="getCustomFieldCellClass(data.field.key, data.item)"
                            :style="getCustomFieldCellStyle(data.field.key, data.item)"
                            class="custom-field-cell-wrapper"
                        >
                            <i v-if="isCustomFieldChecked(data.field.key, data.item)" class="bx bx-check" style="font-size: 1.4em; color: white;"></i>
                            <template v-else-if="isCustomFieldDropdown(data.field.key)">
                                <b-badge
                                    v-if="getSelectedDropdownOption(data.field.key, data.item)"
                                    :style="{ backgroundColor: getSelectedDropdownOption(data.field.key, data.item).color || '#556ee6' }"
                                    class="custom-field-badge"
                                >
                                    {{ getSelectedDropdownOption(data.field.key, data.item).name }}
                                </b-badge>
                            </template>
                            <span v-else-if="!isCustomFieldCheckbox(data.field.key)">{{ data.value }}</span>
                        </div>
                    </template>
                    <template v-else-if="data.field.key.startsWith('progress_')">
                        <div
                            @click.stop="onProgressCellClick(getProgressFromColumnKey(data.field.key), data.item)"
                            class="progress-user-cell-wrapper"
                        >
                            {{ data.value }}
                        </div>
                    </template>
                    <div v-else style="text-align: center">
                        {{ data.value }}
                    </div>
                </template>

                <template #head(show_details)="data">
                    <div style="display: flex; align-items: center">
                        <div class="mr-2" v-html="data.field.label"></div>
                    </div>
                </template>
                <template #cell(show_details)="row">
                    <div style="display: flex; justify-content: center">
                        <i
                            v-b-tooltip.hover
                            :title="$t('general.details')"
                            @click.stop="toggleWorkOrderSteps(row)"
                            :style="{
                                color: row.detailsShowing
                                    ? '#34c38f'
                                    : '#556ee6',
                            }"
                            style="font-size: 1.7em"
                            class="bx bx-detail mr-2"
                        />
                        <i
                            v-b-tooltip.hover
                            :title="$t('general.copy')"
                            v-if="userCanCreateWorkOrder"
                            @click.stop="
                                $root.$emit('copy-workorder', row.item.idPublic)
                            "
                            style="font-size: 1.7em; color: #556ee6"
                            class="bx bx-copy mr-2"
                        />
                        <i
                            v-b-tooltip.hover
                            v-if="userCanCreateWorkOrder"
                            :title="$t('general.edit')"
                            @click.stop="
                                $root.$emit('edit-workorder', row.item.idPublic)
                            "
                            style="font-size: 1.7em; color: #556ee6"
                            class="bx bxs-edit mr-2"
                        />

                        <i
                            v-if="userCanDeleteWorkOrder"
                            v-b-tooltip.hover
                            :title="$t('general.delete')"
                            @click.stop="$emit('delete-workorder', row.item)"
                            variant="danger"
                            style="font-size: 1.7em; color: #f46a6a"
                            class="bx bx-trash"
                        />
                    </div>
                </template>

                <template #row-details="row">
                    <div style="max-width: 100%">
                        <div
                            v-if="row.item.isLoading"
                            style="text-align: center"
                            class="w-100 justify-content-center"
                        >
                            <b-spinner
                                style="color: rgba(243, 168, 33, 0.7) !important"
                                label="Spinning"
                            ></b-spinner>
                        </div>
                        <div
                            v-else
                            v-show="row.item.workOrderProgress"
                            class="zcard zcard-body mb-0"
                            style="
                overflow: auto;
                display: flex;
                flex-wrap: wrap;
                flex-direction: row;
                justify-content: flex-start;
              "
                        >
                            <div
                                v-for="(workOrderProgressItem, index) in row
                                    .item.workOrderProgress"
                                @click="
                                    openWorkOrderProgressDetails(
                                        workOrderProgressItem,
                                        row
                                    )
                                "
                                :key="index"
                                class="mr-4 mb-2"
                                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding: 10px;
                "
                            >
                                <label
                                    style="white-space: nowrap"
                                    class="linkWorkOrderStepHover"
                                >
                                    {{ workOrderProgressItem.progress.name }}
                                    <i
                                        v-if="workOrderProgressItem.isLate"
                                        class="bx bx-time bx-tada"
                                        style="color: #ff0000"
                                    ></i>
                                </label>
                                <radial-progress-bar
                                    :diameter="60"
                                    :strokeWidth="4"
                                    :startColor="
                                        getProgressBarColor(
                                            workOrderProgressItem.percentCompleted
                                        )
                                    "
                                    :stopColor="
                                        getProgressBarColor(
                                            workOrderProgressItem.percentCompleted
                                        )
                                    "
                                    :innerStrokeColor="innerStrokeColor"
                                    :innerStrokeWidth="4"
                                    strokeLinecap="square"
                                    :completed-steps="
                                        workOrderProgressItem.percentCompleted *
                                            100
                                    "
                                    :total-steps="100"
                                >
                                    <span style="font-size: 0.8em"
                                        >{{
                                            Math.floor(
                                                workOrderProgressItem.percentCompleted *
                                                    100
                                            )
                                        }}
                                        %</span
                                    >
                                </radial-progress-bar>
                                <div
                                    v-if="
                                        workOrderProgressItem.dateStarted &&
                                            !workOrderProgressItem.dateDone
                                    "
                                >
                                    {{ $t('general.dateStarted') }}
                                    <div class="text-primary text-center">
                                        {{
                                            $dayjs(
                                                workOrderProgressItem.dateStarted
                                            ).format('L')
                                        }}
                                    </div>
                                </div>
                                <div v-if="workOrderProgressItem.dateDone">
                                    {{ $t('general.dateDone') }}
                                    <div class="text-primary text-center">
                                        {{
                                            $dayjs(
                                                workOrderProgressItem.dateDone
                                            ).format('L')
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </b-table>
            <div class="d-flex align-items-center justify-content-between">
                <b-pagination
                    v-model="page"
                    :total-rows="totalRows"
                    :per-page="pagesize"
                    :first-text="$t('general.first')"
                    :prev-text="$t('general.prev')"
                    :next-text="$t('general.next')"
                    :last-text="$t('general.last')"
                >
                </b-pagination>
                <b-form-group
                    :label="$t('general.itemPerPage')"
                    label-for="pagesize-input"
                    label-cols-sm="8"
                    label-align-sm="right"
                    content-cols-sm="4"
                    class="w-25"
                    ><b-form-select
                        id="pagesize-input"
                        v-model="pagesize"
                        :options="[30, 50, 100]"
                    />
                </b-form-group>
            </div>
        </div>
        <ProgressStartModal ref="progressStartModal" />
        <CompleteStepsBeforeModal ref="completeStepsBeforeModal" />

        <!-- Custom Field Text Edit Modal -->
        <b-modal
            v-model="textEditModal.show"
            :title="textEditModal.customField ? textEditModal.customField.name : $t('general.edit')"
            @ok="saveTextValue"
            :ok-title="$t('general.save')"
            :cancel-title="$t('general.cancel')"
        >
            <b-form-textarea
                v-model="textEditModal.textValue"
                :placeholder="textEditModal.customField ? textEditModal.customField.name : ''"
                rows="4"
                max-rows="10"
            ></b-form-textarea>
        </b-modal>

        <!-- Custom Field Dropdown Edit Modal -->
        <b-modal
            v-model="dropdownModal.show"
            :title="dropdownModal.customField ? dropdownModal.customField.name : $t('general.edit')"
            @ok="saveDropdownValue"
            :ok-title="$t('general.save')"
            :cancel-title="$t('general.cancel')"
        >
            <b-form-group :label="$t('general.selectOption')">
                <b-form-select
                    v-model="dropdownModal.selectedOptionId"
                    :options="dropdownModalOptions"
                ></b-form-select>
            </b-form-group>
        </b-modal>

        <!-- Progress Users Modal -->
        <b-modal
            v-model="progressUsersModal.show"
            :title="progressUsersModal.progress ? progressUsersModal.progress.name : ''"
            @ok="saveProgressUsers"
            :ok-title="$t('general.save')"
            :cancel-title="$t('general.cancel')"
            :ok-disabled="progressUsersModal.isLoading || !progressUsersModal.hasEvent"
        >
            <div v-if="progressUsersModal.isLoading" class="text-center py-3">
                <b-spinner small></b-spinner>
            </div>
            <div v-else-if="!progressUsersModal.hasEvent" class="text-center text-muted py-3">
                {{ $t('general.noEventExists') }}
            </div>
            <multiselect
                v-else
                v-model="progressUsersModal.selectedUsers"
                :options="progressUsersModal.availableUsers"
                :multiple="true"
                :close-on-select="false"
                label="displayName"
                track-by="id"
                :placeholder="$t('general.selectUsers')"
            ></multiselect>
        </b-modal>
    </div>
</template>

<style scoped>
::v-deep .table td.custom-field-td {
    padding: 0;
    height: 1px; /* Trick to allow child to use height: 100% */
}

.custom-field-cell-wrapper {
    cursor: pointer;
    padding: 0.75rem;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.custom-field-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
}
.custom-field-checkbox:hover {
    background-color: rgba(85, 110, 230, 0.1);
}
.custom-field-checkbox-checked:hover {
    filter: brightness(0.85);
}
.custom-field-text,
.custom-field-dropdown {
    align-items: flex-start;
}
.custom-field-text:hover,
.custom-field-dropdown:hover {
    background-color: rgba(85, 110, 230, 0.1);
}
.custom-field-badge {
    font-size: 0.85em;
    font-weight: 500;
    padding: 0.35em 0.65em;
}
.progress-user-cell-wrapper {
    cursor: pointer;
    text-align: center;
    padding: 0.75rem;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}
.progress-user-cell-wrapper:hover {
    background-color: rgba(85, 110, 230, 0.1);
}
</style>
